import { User } from '@sworkit/api';
import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions, fst as firestore } from './firebase';
import { getLoggedInUserId, getLoggedInUserEmail } from './firestore-user';

export type GympassEventType =
  | 'signup'
  | 'signin'
  | 'signup'
  | 'signout'
  | 'audio'
  | 'video'
  | 'cancellation'
  | 'chat'
  | 'content_view'
  | 'create_record'
  | 'no_show'
  | '1_on_1_session'
  | 'other';

export function getGymPassIdFromUserDoc(userDoc: User) {
  const gymPassId =
    userDoc && userDoc.account && userDoc.account.gymPassId
      ? userDoc.account.gymPassId
      : null;
  return gymPassId;
}

export async function logGympassAnalytics(
  gymPassId: string,
  event_type: GympassEventType
) {
  const uid = getLoggedInUserId();
  const email = getLoggedInUserEmail();
  if (!uid || !firestore || !gymPassId) return;
  try {
    const event = {
      user_id: uid,
      gpw_id: gymPassId,
      timestamp: new Date().getTime(),
      event_type,
      email,
    };
    await httpsCallable(firebaseFunctions, 'gympassAnalytics')(event);
  } catch (err) {
    console.error('error with gympass event', err);
  }
}
